import styled, { css } from 'styled-components';
import { Image } from '@landr/maestro';
import { StyledBackgroundImageProps } from './types';
import backgroundImageStyles from './themes/BackgroundImage.default';

const backgroundImageBaseStyles = css`
    position: absolute;
    object-fit: cover;
    object-position: center center;
    height: 101%; /* prevent 1px border under certain ratio */
    width: 101%;
`;

export const BackgroundImage = styled(Image)<StyledBackgroundImageProps>`
    ${backgroundImageBaseStyles};
    ${backgroundImageStyles.root};
    ${({ bgPosition }) => backgroundImageStyles.position[bgPosition]};
    ${({ zoom }) =>
        `width: calc( ${zoom} * 101% ); height: calc( ${zoom} * 101% );`};
`;
